import { render, staticRenderFns } from "./EditUserPreferences.vue?vue&type=template&id=79a34f43&scoped=true&"
import script from "./EditUserPreferences.vue?vue&type=script&lang=js&"
export * from "./EditUserPreferences.vue?vue&type=script&lang=js&"
import style0 from "./EditUserPreferences.vue?vue&type=style&index=0&id=79a34f43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a34f43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a34f43')) {
      api.createRecord('79a34f43', component.options)
    } else {
      api.reload('79a34f43', component.options)
    }
    module.hot.accept("./EditUserPreferences.vue?vue&type=template&id=79a34f43&scoped=true&", function () {
      api.rerender('79a34f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditUserPreferences.vue"
export default component.exports